module.exports = __webpack_public_path__ + "img/zhinengjiaju8.3dffffd9.jpg";